import { createVNode as i, mergeProps as n } from "vue";
import T from "../node_modules/@pf-ui/pf-icon-svg/es/asn/TitleTwoTone.js";
import l from "../components/PfIcon.js";
const o = (e, t) => {
  const r = {
    ...e,
    ...t.attrs
  };
  return i(l, n(r, {
    icon: T
  }), null);
};
o.displayName = "TitleTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
